<div id="home" class="home">
  <div class="my-3 my-md-5">
    <div class="container">

      <div class="card">
        <div class="card-status bg-blue"></div>
        <div class="card-header">
          <h3 class="card-title">Personnel</h3>
          <div class="card-options">
            <button class="btn btn-sm btn-default" (click)="newTechnicien()">
              <span class="fe fe-plus"></span>
            </button>
          </div>
        </div>
        <div class="card-body">
          <table class="table card-table table-hover table-vcenter">
            <thead>
              <tr>
                <th>Actifs</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let technicien of techniciensActifs" (click)="goTechnicien(technicien.id)">
                <td>
                  <span>{{technicien.prenom}} {{technicien.nom}}</span>
                  <span class="float-right">{{technicien.tel}}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="card-body">
          <table class="table card-table table-hover table-vcenter">
            <thead>
              <tr>
                <th>Inactifs</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let technicien of techniciensInactifs" (click)="goTechnicien(technicien.id)">
                <td>
                  <span>{{technicien.prenom}} {{technicien.nom}}</span>
                  <span class="float-right">{{technicien.tel}}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>
  </div>
</div>
